exports = module.exports = require("../../node_modules/.registry.npmjs.org/css-loader/0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes loader-inner {\r\n    0% {\r\n      height: 0%;\r\n    }\r\n    \r\n    25% {\r\n      height: 0%;\r\n    }\r\n    \r\n    50% {\r\n      height: 100%;\r\n    }\r\n    \r\n    75% {\r\n      height: 100%;\r\n    }\r\n    \r\n    100% {\r\n      height: 0%;\r\n    }\r\n  }\r\n.loader {\r\n    position: absolute;\r\n    top: calc(50% - 58px);\r\n    z-index: 9999;\r\n    left: calc(50% - 58px);\r\n    background: rgba(0,0,0,0.1);\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n}\r\n  \r\n  .loader-inner {\r\n    vertical-align: top;\r\n    display: inline-block;\r\n    width: 100%;\r\n    background-color: #fff;\r\n    animation: loader-inner 2s infinite ease-in;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/Karry/Zoom/ZoomCustomer/src/app/app.component.css
// module id = ../../../../../../../../../../src/app/app.component.css
// module chunks = main